import React from "react";
import $ from 'jquery';
import ProductService from '../services/product';

import OrderService from '../services/order';

import Utility from "../utilities/utility";
import Modal from 'react-bootstrap/Modal';

import AuthorizationCheck from '../auth/authorizationCheck';

class AddSupplierOrderProduct extends React.Component {

    constructor() {
        super();

        const queryParams = new URLSearchParams(window.location.search);

        this.state = {
            products: [],

            order: [],
            confirmationProductData: [],
            confirmAddProduct : false,
            currentUserRole: '',
            timeoutId: null
        };



        this.orderId = localStorage.getItem('selectedSupplierOrder');

        console.log(this.orderId);
    }

    componentDidMount() {

        this.productsTorder();

        this.getSupplierOrder();



    }





    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.productsTorder();
        }, 1500);

        this.setState({ timeoutId: timer })
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    

    addToOrder = async (id, productId, price, e, confirmed = false) => {

        e.preventDefault();

        const orderId = this.orderId;

        let oldProductList = this.state.products;


        let quantity = $('#product-qty-' + id).val();

        console.log(orderId);


        if (Utility.isEmpty(orderId) || Utility.isEmpty(quantity)) {

            $('#product-row-' + id).before(
                '<div class="alert alert-danger order-product-alert">Erreur</div>'
            )

            $('.order-product-alert').delay(3000).fadeOut('slow');

            return;
        }
        

        let holder = 'product-row-' + id;

        try {

            const response = await OrderService.addSupplierOrderProductToOrder(orderId, productId, quantity, price, confirmed);


            if (response.ok) {


                $('#product-qty-' + id).val('')

                
                let products = oldProductList.content.filter((p) => {

                    if (p.productId == productId) {

                        let remainingQty = p.quantity - quantity;

                        /*if (remainingQty < 0) {

                            remainingQty = 0;
                        }*/

                        p.quantity = remainingQty;

                        return p;
                    }

                    return p;

                });


                oldProductList.content = products;


                this.setState({

                    products: oldProductList
                });

                Utility.showAlertWithId(holder, 'Produit Ajouté', 'success', true);

            } else if(response.status === 409){


                this.setState({

                    confirmationProductData: {

                        id : id,
                        productId : productId,
                        price : price,
                        event:e
                        
                    },
                    confirmAddProduct : true
                });
                
            }
            else {

                Utility.showAlertWithId(holder, 'Erreur', 'danger', true);
            }

        } catch (error) {

            console.log(error);

            Utility.showAlertWithId(holder, 'Erreur', 'danger', true);
        }




    }


    hideProductConfirmationForm = () => {

        this.setState({

            confirmAddProduct: false
        });
    }

    readdProductToOrder = () => {

        let productData = this.state.confirmationProductData;

        this.addToOrder(productData.id, productData.productId, productData.price, productData.event, true);
        this.hideProductConfirmationForm();
    }

    productsTorder = async (page) => {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let size = $('#size').val();

        try {
            const response = await OrderService.productsToOrderFromSupplier(name, model, brand, size, page, null);

            let products = [];
            if (response.status === 200) {

                products = await response.json();
            }

            this.setState({
                products: products
            });




        } catch (error) {
            console.log(error)
        }



    }


    getSupplierOrder = async () => {


        try {

            const orderId = this.orderId;

            if (Utility.isEmpty(orderId)) {

                return;
            }
            const response = await OrderService.fetchSupplierOrder(orderId);

            if (response.ok) {

                this.setState(
                    {
                        order: await response.json()
                    }
                );
            }




        } catch (error) {
            console.log(error)
        }



    }

    loadNextPage = (offset, e) => {

        e.preventDefault();

        this.productsTorder(offset);
    }



    render() {

        const products = this.state.products;

        const order = this.state.order;

        let nextPage = '';

        let navLinks = '';

        if(!Utility.isEmpty(products) && !Utility.isEmpty(products.pageable) && products.pageable.pageNumber <= products.totalPages){

            nextPage = products.pageable.pageNumber + 1;
        }

        console.log(nextPage);

        if(!Utility.isEmpty(nextPage)){


            navLinks = <nav aria-label="Page navigation example">
                    <ul className="pagination mt-2">
                        
                        
                        <li className="page-item"><a className="page-link" href="#"><button className="btn btn-primary" onClick={(e) => this.loadNextPage(nextPage, e)}>Next</button></a></li>
                    </ul>
                </nav>

        }


        let orderDetails = '';

        if (!Utility.isEmpty(order)) {

            $('#order-details').show();



            orderDetails = <div className="abs-box">

                <div className="text-start fw-bold">Fournisseur: <span className="text-info">{order.supplierName}</span></div>
                <div className="text-start fw-bold">Commande Choisi: <span className="text-primary">{order.description}</span></div>

            </div>

        }

        return (

            <div className=" container product-wrapper mt-3">
                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />







                <div id="order-details" style={{ display: 'none' }}>{orderDetails}</div>

                <h2 className="mb-3">Ajoute Produits</h2>





                <div className="messageHolder"></div>

                <Modal show={this.state.confirmAddProduct}>
                    <Modal.Header closeButton onHide={this.hideProductConfirmationForm}>Confirme Ajout du Produit</Modal.Header>
                    <Modal.Body>



                        <div className="form-wrapper mt-4">

                            <div className="messageHolder"></div>


                            <div className="form-group">
                                <p className="label text-center">Ce produit a été deja ajouté. Voulez vous ajouter ce produit encore?</p>
                                <button className='btn btn-danger full-width' onClick={this.readdProductToOrder}>Ajoute</button>
                            </div>


                        </div>



                    </Modal.Body>

                </Modal>


                <div className="form-wrapper">




                    <div className="row">
                        <div className="col">


                            <div className="form-group">
                                <input className="form-control" id="name" placeholder="Nom" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                                <input className="form-control" id="model" placeholder="Model" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">

                            <div className="form-group">
                                <input className="form-control" id="brand" placeholder="Marque" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                                <input className="form-control" id="size" placeholder="Numero ou CPID" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                    </div>




                </div>



                <div className="card card-default mt-5 bg-primary text-white">

                    <div className="card-body">
                        <div className="row">
                            <div className="col">Description</div>
                            <div className="col">Prix</div>
                            <div className="col"></div>
                            <div className="col">Quantité</div>
                            <div className="col"></div>
                            <div className="col"></div>
                        </div>
                    </div>
                </div>

                {products.content != null && products.content.length > 0 && products.content.map(product =>

                    <div className="card card-default mt-2" key={product.productId}>

                        <div className="card-body" id={"product-row-" + product.productId}>
                            <div className="row">
                                <div className="col">{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                                <div className="col">{product.price}</div>
                                <div className="col">CPID: {product.supplierUniqueId}</div>
                                <div className="col" id={"epq-" + product.productId}>{product.quantity}</div>
                                <div className="col">
                                    <div className="form-group">
                                        <input className="form-control" id={"product-qty-" + product.productId} placeholder="Quantité Desirée" />
                                    </div>

                                </div>
                                <div className="col">
                                    <button className="btn btn-primary full-width-btn" onClick={(e) => this.addToOrder(product.productId, product.productId, product.price, e)}>Ajoute</button>

                                </div>
                            </div>
                        </div>
                    </div>

                )
                }


                { navLinks }





            </div>



        );
    }


}

export default AddSupplierOrderProduct;